import { render, staticRenderFns } from "./bullet-points-controls.vue?vue&type=template&id=4ba30bd9&scoped=true&"
import script from "./bullet-points-controls.vue?vue&type=script&lang=js&"
export * from "./bullet-points-controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba30bd9",
  null
  
)

export default component.exports